import { derived, readable, writable } from 'svelte/store'
import Kategori from '../components/kategori/kategori.svelte'
import Landingsside from '../components/landingsside/landingsside.svelte'

export const routes = readable([
  { name: 'landing', path: '/', component: Landingsside },
  { name: 'kategori', path: '/k/:slug', component: Kategori },
])

export const baseUrl = writable('')

export const currentRoute = writable({ name: undefined, params: {} })

export const currentRouteComponent = derived([currentRoute, routes], ([$current, $routes]) => {
  return $routes.find((r) => r.name === $current.name)?.component
})
